import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const VACATION_HOME = {
  nickname: 'PRODUCTS.VACATION_HOME.nickname',
  LIST_OF_OBJECTS: ['houseWithContents', 'houseAdditionalBuildings'],
  properties: [
    { name: 'productPackage', key: 'PRODUCT_PACKAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.STANDARD', value: 'STANDARD' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.ELITE', value: 'SUPER' }
        ]
      }
    },
    { name: 'deductible', key: 'DEDUCTIBLE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.5', value: 5000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.75', value: 7500 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.10', value: 10000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.15', value: 15000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.20', value: 20000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.25', value: 25000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.30', value: 30000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.50', value: 50000 }
        ]
      }
    },
    { name: 'houseSumInsuredType', key: 'SUM_INSURED_TYPE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      isFirstRiskSumInsuredCheck: true,
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SUM_INSURED_TYPE.FULL_VALUE', value: 'FULL_VALUE' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SUM_INSURED_TYPE.FIRST_RISK', value: 'FIRST_RISK' },
        ]
      }
    },
    { name: 'houseFirstRiskSumInsured', key: 'SUM_INSURED', group: 'INSURANCE_INFO' },
    // { name: 'houseSumInsured', key: 'SUM_INSURED', group: 'INSURANCE_INFO',
    //   inputType: INPUT_TYPES_CONFIG.TEL,
    //   validator: ['', [
    //     Validators.required
    //   ]]
    // },
    { name: 'calculatedClientAge', key: 'CLIENT_AGE', group: 'OBJECT_INFO' },
    { name: 'objectZipCode', key: 'OBJECT_ZIP_CODE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      validator: ['', [
        Validators.required,
        Validators.pattern('[0-9]{4}$')
      ]]
    },
    { name: 'houseBuildingYear', key: 'BUILDING_YEAR', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.DATE,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        dateView: 'multi-years'
      }
    },
    {
      name: 'wtcHouseownerBasementDry', key: 'HOUSE_OWNER_BASEMENT_DRY', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'houseSMBurglarAlarmConnected', key: 'HOUSE_SM_BURGAR_ALARM_CONNECTED', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'houseSMFireAlarmConnected', key: 'HOUSE_SM_FIRE_ALARM_CONNECTED_SCOOPR', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'houseBuildingMaterials', key: 'BUILDING_MATERIALS', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_MATERIALS.WOOD', value: 'WOOD' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_MATERIALS.CONCRETE', value: 'CONCRETE' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_MATERIALS.MUR', value: 'MUR' },
        ]
      }
    },
    { name: 'houseIsRented', key: 'HOUSE_IS_RENTED_WTC', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'wtcWaterSecurity', key: 'WTC_WATER_SECURITY', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_WATER_SECURITY.MAIN_STOPCOCK_IS_CLOSED_WHEN_HOME_IS_UNOCCUPIED', value: 'MAIN_STOPCOCK_IS_CLOSED_WHEN_HOME_IS_UNOCCUPIED' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_WATER_SECURITY.NO_WATER', value: 'NO_WATER' },
        ]
      }
    },
    { name: 'houseNumberOfBathrooms', key: 'HOUSE_NUMBER_OF_BATHROOMS', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.NUMBER,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'wtcRoad', key: 'WTC_ROAD', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_ROAD.NO_ROAD', value: 'NO_ROAD' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_ROAD.HALF_YEAR_ROAD', value: 'HALF_YEAR_ROAD' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_ROAD.YEAR_ROUND_ROAD', value: 'YEAR_ROUND_ROAD' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_ROAD.ISLAND', value: 'ISLAND' },
        ]
      }
    },
    { name: 'houseWithContents', key: 'HOUSE_WITH_CONTENTS', group: 'INSURANCE_INFO',
      values: [
        { name: 'productPackage', key: 'PRODUCT_PACKAGE', group: 'INSURANCE_INFO',
          inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.STANDARD', value: 'STANDARD' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.ELITE', value: 'SUPER' }
            ]
          }
        },
        {
          name: 'deductible',
          key: 'DEDUCTIBLE',
          group: 'INSURANCE_INFO',
          inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.5', value: 5000 },
              { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.75', value: 7500 },
              { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.10', value: 10000 },
              { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.15', value: 15000 },
              { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.20', value: 20000 },
              { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.25', value: 25000 },
              { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.30', value: 30000 },
              { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_HOUSE.50', value: 50000 }
            ]
          }
        },
        { name: 'productSumInsured', key: 'SUM_INSURED', group: 'INSURANCE_INFO',
          inputType: INPUT_TYPES_CONFIG.NUMBER,
          validator: ['', [
            Validators.required
          ]]
        }
      ]
    },
    { name: 'houseAdditionalBuildings', key: 'HOUSE_ADDITIONAL_BUILDINGS', group: 'OBJECT_INFO',
      values: [
        { name: 'houseSumInsuredType', key: 'SUM_INSURED_TYPE', group: 'INSURANCE_INFO',
          inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
          validator: ['', [
            Validators.required
          ]],
          isFirstRiskSumInsuredCheck: true,
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SUM_INSURED_TYPE.FULL_VALUE', value: 'FULL_VALUE' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SUM_INSURED_TYPE.FIRST_RISK', value: 'FIRST_RISK' },
            ]
          }
        },
        { name: 'houseFirstRiskSumInsured', key: 'SUM_INSURED', group: 'INSURANCE_INFO' },
        { name: 'houseBuildingType', key: 'BUILDING_TYPE', group: 'OBJECT_INFO',
          inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.MORGUE', value: 'Bårehus' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.CARPORT', value: 'Carport' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.WTC_GARAGE_NOT_ISOLATED', value: 'Garasje tre. uisolert' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.WTC_GARAGE_ISOLATED', value: 'Garasje mur / isolert tre' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.WTC_ROW_GARAGE', value: 'Rekkegarasje' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.WTC_LOGCABIN_NOT_ISOLATED', value: 'Stabbur. uisolert' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.WTC_LOGCABIN_MACHINE',
                value: 'Stabbur. maskinlaftet tømmer/isolert' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.WTC_LOGCABIN_BY_HAND', value: 'Stabbur. håndlaftet tømmer' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.WTC_SHED_NOT_ISOLATED', value: 'Uthus tre. uisolert' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.WTC_SHED_ISOLATED', value: 'Uthus mur / isolert tre' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.WTC_ANNEX', value: 'Anneks' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.WTC_BOAT_HOUSE_ISOLATED', value: 'Båthus isolert' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.WTC_BOAT_HOUSE_NOT_ISOLATED', value: 'Båthus uisolert' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.WTC_UNDER_50_ISOLETED', value: 'Driftsbygning/uthus under 50 % isolert' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.WTC_OVER_50_ISOLETED',
                value: 'Driftsbygning/uthus over 50 % isolert' },
            ]
          }
        },
        { name: 'houseSquareMeters', key: 'SQUARE_METERS', group: 'OBJECT_INFO',
          inputType: INPUT_TYPES_CONFIG.NUMBER,
          validator: ['', [
            Validators.required
          ]]
        },
        { name: 'houseStandardCategory', key: 'HOUSE_STANDARD_CATEGORY', group: 'INSURANCE_INFO',
          inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_STANDARD_CATEGORY.NORMAL', value: 'NORMAL' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_STANDARD_CATEGORY.BETTER', value: 'BETTER' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_STANDARD_CATEGORY.STANDARD', value: 'STANDARD' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_STANDARD_CATEGORY.EXCLUSIVE', value: 'EXCLUSIVE' }
            ]
          }
        },
        // {
        //   name: 'houseAdditionalBuildingBuiltYear',
        //   key: 'HOUSE_ADDITIONAL_BUILDING_BUILT_YEAR',
        //   inputType: INPUT_TYPES_CONFIG.DATE,
        //   validator: ['', [
        //     Validators.required
        //   ]],
        //   settings: {
        //     dateView: 'multi-years'
        //   }
        // }
      ]
    },
    {
      name: 'wtcHouseownerMushroom', key: 'HOUSE_OWNER_MUSHROOM', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    // {
    //   name: 'wtcExclusiveContent', key: 'WTC_EXCLUSIVE_CONTENT', group: 'INSURANCE_INFO',
    //   inputType: INPUT_TYPES_CONFIG.BOOLEAN,
    //   validator: ['', [
    //     Validators.required
    //   ]]
    // },
    { name: 'houseStandardCategory', key: 'HOUSE_STANDARD_CATEGORY', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_STANDARD_CATEGORY.NORMAL', value: 'NORMAL' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_STANDARD_CATEGORY.BETTER', value: 'BETTER' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_STANDARD_CATEGORY.STANDARD', value: 'STANDARD' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_STANDARD_CATEGORY.EXCLUSIVE', value: 'EXCLUSIVE' }
        ]
      }
    },
    { name: 'houseBuildingType', key: 'BUILDING_TYPE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.HYTTE', value: 'CABIN' }
        ]
      }
    },
    // { name: 'wtcRate', key: 'WTC_RATE', group: 'INSURANCE_INFO',
    //   inputType: INPUT_TYPES_CONFIG.NUMBER,
    //   validator: ['', [
    //     Validators.required
    //   ]]
    // },
    { name: 'houseSquareMeters', key: 'SQUARE_METERS', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.NUMBER,
      validator: ['', [
        Validators.required
      ]]
    },
    // { name: 'wtcSumContentFactor', key: 'WTC_SUM_CONTENT_FACTOR', group: 'INSURANCE_INFO',
    //   inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
    //   validator: ['', [
    //     Validators.required
    //   ]],
    //   settings: {
    //     list: [
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_SUM_CONTENT_FACTOR.ZERO', value: 'ZERO' },
    //       { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_SUM_CONTENT_FACTOR.AMOUNT_1500000', value: 'AMOUNT_1500000' },
    //     ]
    //   }
    // }
  ],
  icon:'vacation-home'
};
